module.exports = __webpack_public_path__ + "media/images/iconEdit__inactive-90a9c7a26989b206bb0d3e24a50c538a.png";